jQuery(document).ready(function($) {

    $(".bloc_separateur").each(function() {
        var bloc = this
        var img = bloc.querySelector(".photo img")

        if (img) {
            gsap.fromTo(img,
                { y: "-25%" },
                {
                    y: "0%",
                    ease: "none",
                    scrollTrigger: {
                        trigger: bloc,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true
                    }
                }
            )
        }
    })

});
